import { useAuth0 } from "@auth0/auth0-react";
import { Auth0AuthenticationGuard } from "services/auth/auth0/authentication-guard";
import { Auth0ProviderWithNavigate } from "services/auth/auth0/provider";

export const auth0Service = {
    useAuthHook: useAuth0,
    AuthProviderComponent: Auth0ProviderWithNavigate,
    AuthenticationGuard: Auth0AuthenticationGuard,
}
